unit unit_AenderungZugangsdaten;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, DB;

type
  TAenderungZugangsdaten = class(TForm)
    TC: TTableControl;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    WebMessageDlg1: TMessageDlg;
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    Aenderungsart:integer;
    btnAbsenden:TButton;
    buttonzurueck:TButton;
    procedure btnAbsendenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure FormularErstellen;
  protected procedure LoadDFMValues; override; end;

var
  AenderungZugangsdaten: TAenderungZugangsdaten;
  edtPasswortAlt:TEdit;
  edtPasswortNeu1:TEdit;
  edtPasswortNeu2:TEdit;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TAenderungZugangsdaten.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAenderungZugangsdaten.btnAbsendenclick(Sender:TObject);
var
  istsicher1:boolean;
  istsicher2:boolean;
  istsicher3:boolean;
  tmppw:string;
  i:integer;
begin
    if edtPasswortNeu1.Text='' then
    begin
      showmessage('Sie haben kein neues Passwort eingegeben');
      exit;
    end;
    if edtPasswortNeu2.Text='' then
    begin
      showmessage('Sie haben keine Passwortwiederholung eingegeben');
      exit;
    end;
    if edtPasswortAlt.Text='' then
    begin
      showmessage('Sie haben das bisherige Passwort nicht eingegeben');
      exit;
    end;
    if length(edtPasswortNeu1.Text)<8 then
    begin
      showmessage('Das Passwort muss mindestens 8 Zeichen lang sein');
      exit;
    end;
    if edtPasswortNeu1.Text<>edtPasswortNeu2.text then
    begin
      showmessage('Die neuen Passwörter stimmen nicht überein');
      exit;
    end;
    if edtPasswortAlt.Text<>xdsKundendatenLoginPW.asstring then
    begin
      showmessage('Das eingegebene bisherige Passwort ist falsch');
      exit;
    end;
    if edtPasswortAlt.Text=edtPasswortNeu1.text then
    begin
      showmessage('Das bisherige und das neue Passwort sind identisch');
      exit;
    end;

    tmppw:=edtPasswortNeu1.Text;
    for i := 1 to length(tmppw) do
    begin
      if tmppw[i] in ['A'..'Z'] then istsicher1:=true;
      if tmppw[i] in ['a'..'z'] then istsicher2:=true;
      if tmppw[i] in ['0'..'9'] then istsicher3:=true;
    end;

    if not istsicher1 then
    begin
      showmessage('Ihr Passwort muß mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten');
      exit;
    end;
    if not istsicher2 then
    begin
      showmessage('Ihr Passwort muß mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten');
      exit;
    end;
    if not istsicher3 then
    begin
      showmessage('Ihr Passwort muß mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten');
      exit;
    end;




    dm2.xdsProtokoll.Append;
    dm2.xdsProtokollDatum.AsDateTime:=date+time;
    dm2.xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
    dm2.xdsProtokollNotiz.AsString:='Passwort wurde geändert '+InternetIpAdresse;
    dm2.xdsProtokoll.Post;
    dm2.xdsProtokoll.ApplyUpdates;
    xdsKundendaten.Edit;
    xdsKundendatenLoginPW.AsString:=edtPasswortNeu1.Text;
    xdskundendaten.Post;
    xdsKundendaten.ApplyUpdates;

end;

procedure TAenderungZugangsdaten.FormularErstellen;
var
  myelement:TJSHTMLElement;
  i:integer;
begin

  TC.ColCount:=1;
  TC.RowCount:=9;
  TC.Cells[0,i]:='<h4>Änderung Zugangsdaten';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Kundennummer <br><b>'+xdsKundendatenKundennummer.asstring;
  inc(i);

  TC.Cells[0,i]:='Emailadresse <br><b>'+xdsKundendatenEMail.AsString;

  inc(i);
  TC.Cells[0,i]:='Ihr bisheriges Passwort* <br>';
  myelement:=TC.CellElements[0,i];
  edtPasswortAlt:=TEdit.Create(self);
  edtPasswortAlt.ElementClassName:='form-control';
  edtPasswortAlt.Width:=400;
  edtPasswortAlt.HeightStyle:=ssAuto;
  edtPasswortAlt.TextHint:='';
  edtPasswortAlt.PasswordChar:='*';
  edtPasswortAlt.MaxLength:=20;
  edtPasswortAlt.Text:='';
  edtPasswortAlt.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Ihr neues Passwort* <br>';
  myelement:=TC.CellElements[0,i];
  edtPasswortNeu1:=TEdit.Create(self);
  edtPasswortNeu1.ElementClassName:='form-control';
  edtPasswortNeu1.Width:=400;
  edtPasswortNeu1.HeightStyle:=ssAuto;
  edtPasswortNeu1.TextHint:='';
  edtPasswortNeu1.PasswordChar:='*';
  edtPasswortNeu1.MaxLength:=20;
  edtPasswortNeu1.Text:='';
  edtPasswortNeu1.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Ihr neues Passwort* (Wiederholung) <br>';
  myelement:=TC.CellElements[0,i];
  edtPasswortNeu2:=TEdit.Create(self);
  edtPasswortNeu2.ElementClassName:='form-control';
  edtPasswortNeu2.Width:=400;
  edtPasswortNeu2.HeightStyle:=ssAuto;
  edtPasswortNeu2.TextHint:='';
  edtPasswortNeu2.PasswordChar:='*';
  edtPasswortNeu2.MaxLength:=20;
  edtPasswortNeu2.Text:='';
  edtPasswortNeu2.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  btnAbsenden:=TButton.Create(self);
  btnAbsenden.ElementClassName:='btn btn-info text-left';
  btnAbsenden.HeightStyle:=ssauto;
  btnAbsenden.WidthStyle:=ssauto;
  btnAbsenden.tag:=0;
  btnAbsenden.Caption:='Änderungen speichern';
  btnAbsenden.OnClick:=@btnAbsendenClick;
  btnAbsenden.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='*)= Das Passwort muß mindestens 8 Zeichen lang sein, einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten';

  edtPasswortAlt.SetFocus;


end;

procedure TAenderungZugangsdaten.WebFormShow(Sender: TObject);
begin
  dm2.xdsProtokoll.Close;
  dm2.xdsProtokoll.Load;
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TAenderungZugangsdaten.xdsKundendatenAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

  if info.Records[0].Error='' then
  begin
    showmessage('Ihre Änderung war erfolgreich. Sie müssen sich jetzt neu anmelden.');
    close;
  end;

end;

procedure TAenderungZugangsdaten.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  FormularErstellen;
end;

procedure TAenderungZugangsdaten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  try
    Name := 'AenderungZugangsdaten';
    Width := 189;
    Height := 362;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 161;
    TC.Height := 314;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 24;
    WebMessageDlg1.Top := 320;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebMessageDlg1.ElementButtonClassName := 'btn btn-info';
    WebMessageDlg1.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg1.ElementTitleClassName := 'text-body';
    WebMessageDlg1.ElementContentClassName := 'text-body';
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 40;
    xdsKundendaten.Top := 104;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
  finally
    TC.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
  end;
end;

end.